import { useTranslation } from "react-i18next";
import {
  Box,
  SpanStyled,
  SubHeadingStyled,
} from "../../../../components/styled/Elements";
import { FormRadioWrapper } from "./AccessSettings";
import { Field, ErrorMessage, useFormikContext } from "formik";
import useCabinetOptions from "../../../../hooks/useCabinetOptions";

const MySelfDepartmentOptions = () => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext();
  const { myself } = useCabinetOptions();

  return (
    <Box className="optionsContent">
      <SubHeadingStyled
        size="15px"
        weight={700}
        color={"var(--text)"}
        className="px-4 pt-4 pb-0"
      >
        {t("myself")}
      </SubHeadingStyled>

      <Box className="w-100 p-2">
        {myself.map((option, i) => (
          <Box
            key={option.id || i}
            className={`w-100 p-2 ${
              i !== myself.length - 1 ? "separation-border" : ""
            }`}
          >
            <FormRadioWrapper>
              <Field
                type="radio"
                name="setting_id"
                className="radio-input"
                value={option.id}
                checked={values.setting_id === option.id}
                onChange={(e) => {
                    setFieldValue("setting_id", Number(e.target.value));
                    setFieldValue("my_department_id", null);
                    setFieldValue("my_dept_ids", []);
                    setFieldValue("other_department_id", null);
                    setFieldValue("other_dept_ids", []);
                    setFieldValue("from_branches", []);
                    setFieldValue("from_departments", []);
                    setFieldValue("referrals", []);
                }}
              />

              <SpanStyled
                size="16px"
                color="var(--text)"
                checked={values.setting_id === option.id}
                className="radio-label"
              >
                {t(option.title)}
              </SpanStyled>
            </FormRadioWrapper>
          </Box>
        ))}

        {/* ✅ ERROR MESSAGE */}
        <ErrorMessage
          name="setting_id"
          component="div"
          className="text-danger text-sm mb-0 mt-1"
        />
      </Box>
    </Box>
  );
};

export default MySelfDepartmentOptions;